// The application's query client, and how long what it holds stays fresh.
//
// Freshness follows the kind of data. What a person or a document recorded
// changes only by a write, and a write invalidates what it changes: fresh for
// half a minute. What changes on its own, a quote or a feed, is polled and
// fresh until its next poll (`polled`). What changes only with a deploy is
// fresh for good (`staleTime: Infinity`). An answer no page shows is kept for
// half an hour, a dashboard's for the session (`kept`).

import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
        gcTime: 30 * 60_000,
      },
    },
  });
}

/** A query asked again every `ms`, and fresh until then. */
export const polled = (ms: number) => ({ refetchInterval: ms, staleTime: ms }) as const;

/** Kept for the whole session, so a later visit paints at once. */
export const kept = { gcTime: Infinity } as const;
